module.exports = __webpack_public_path__ + "static/tlo_wenecja@2x-d48fc4c6589c1d92c7e2eaa3ce3b5f49.png";